/**
 * Settings module translations - Labels section
 */

const labels = {
  peppolNumber: "Peppol Number",
  enterPeppolNumber: "Enter Peppol Number",
  taxId: "Tax ID",
  enterTaxId: "Enter Tax ID",
  country: "Country",
  enterCountry: "Enter your Country",
  language: "Language",
  selectLanguage: "Select language...",
  languageForPDFs: "Language for PDFs",
  others: "Others",
  active: "Active",
  companyName: "Company Name",
  products: "Products",
  ksefToken: "KSeF token",
  ksefTokenShow: "Show token",
  ksefTokenHide: "Hide token",
  editLanguageForPDFs: "Edit Language for PDFs",
  setLanguageForPDFs: "Set Language for PDFs",
  deleteCountry: "Delete Country",
  deleteCountryConfirmation: "Are you sure you want to delete the country",
  changePeppolStatus: "Change Peppol Status",
  editPeppolVerification: "Edit Peppol Verification",
  applyForPeppolNumber: "Apply for Peppol Number",
  completeRegistrationProcess: "Complete the registration process in 4 simple steps",
  companyInformation: "Company Information",
  attachIdentityDocument: "Attach Identity Document",
  downloadDocument: "Download Document",
  uploadSignedDocument: "Upload Signed Document",
  selectStatus: "Select Status",
  chooseStatus: "Choose status...",
  rejectionNotes: "Rejection Notes",
  enterRejectionReason: "Enter reason for rejection...",
  approved: "Approved",
  rejected: "Rejected",
  uploadRequiredDocuments: "Please upload the required documents for Peppol verification. You can upload 1-2 files maximum.",
  identityFile: "Identity File",
  agreementFile: "Agreement File",
  uploadIdentityFile: "Upload identity file",
  uploadAgreementFile: "Upload agreement file",
  uploadedFiles: "Uploaded files:",
  invalidFileFormat: "Invalid file format. Only JPEG, JPG, PNG, and PDF files are allowed.",
  selectAtLeastOneFile: "Please select at least one file to upload",
  changeStatus: "Change Status",
  addVatNumber: "Add VAT number",
  selectCountry: "Select country",
  selectDate: "Select date",
  typeOfActivity: "Type of activity",
  nexusEstablished: "Nexus Established",
  validFrom: "Valid from",
  validTill: "Valid till",
  notUsedForInvoice: "This number will <strong>not be used</strong> for L'Invoice",
  reasonForRegistration: "Reason for registration",
  sku: "SKU",
  description: "Description",
  classificationCode: "Classification code",
  classificationCodeWithCountry: "{{countryName}} classification code",
  searchClassificationCode: "Type code or description to search…",
  noMatches: "No matches",
};

export default labels;
